import { useEffect } from "react";
export var useKeyPress = function useKeyPress(targetKey, handler) {
  var downHandler = function downHandler(_ref) {
    var key = _ref.key;

    if (key === targetKey) {
      handler();
    }
  };

  useEffect(function () {
    window.addEventListener("keydown", downHandler); // Remove event listeners on cleanup

    return function () {
      window.removeEventListener("keydown", downHandler);
    };
  });
};